import asphaltCutter from "../../static/asfaltsskarare.webp";
import GB from "../../static/avjamningsbalk.webp";
import gravskopaTeeth from "../../static/gravskopa-teeth.webp";
import RG from "../../static/gripmodul.webp";
import jarnvagsgrip from "../../static/jarnvagsgrip.webp";
import compactor from "../../static/markvibrator.webp";
import MC_S from "../../static/maskinfaste-sfaste.webp";
import multigrip from "../../static/multigrip.webp";
import QC from "../../static/QC-faste.webp";
import RC5_produktbild from "../../static/RC5_produktbild.webp";
import redskapsinfastning from "../../static/redskapsinfastning.webp";
import ripper from "../../static/rivtand.webp";
import SOG from "../../static/soteringsgrip.webp";
import stengrip from "../../static/stengrip.webp";
import R1 from "../../static/R1_1100x1400.webp";
import R2 from "../../static/R2_1100x1400.webp";
import R3 from "../../static/R3_1100x1400.webp";
import R4 from "../../static/R4_1100x1400.webp";
import R5 from "../../static/R5_1100x1400.webp";
import R6 from "../../static/R6_1100x1400.webp";
import R8 from "../../static/R8_1100x1400.webp";
import RC1 from "../../static/RC1_1100x1400.webp";
import RC2 from "../../static/RC2_1100x1400.webp";
import RC3 from "../../static/RC3_1100x1400.webp";
import RC4 from "../../static/RC4_1100x1400.webp";
import RC5 from "../../static/RC5_1100x1400.webp";
import RC6 from "../../static/RC6_1100x1400.webp";
import RC8 from "../../static/RC8_1100x1400.webp";
import RC9 from "../../static/RC9_1100x1400.webp";
import MG from "../../static/Grapple_MG_1100x1400px.webp";
import SG from "../../static/Grapple_SG_1100x1400px.webp";
import GradingBucket from "../../static/Universal_bucket_1100x1400.webp";
import TrenchingBucket from "../../static/Trenching_bucket_1100x1400.webp";
import SortingBucket from "../../static/Sorting_bucket_1100x1400.webp";
import ExcavationBucketTeeth from "../../static/Digging_Bucket_T_1100x1400.webp";
import ExcavationBucket from "../../static/Digging_bucket_1100x1400.webp";

export const localImages = {
    asphaltCutter,
    GB,
    gravskopaTeeth,
    RG,
    jarnvagsgrip,
    compactor,
    MC_S,
    multigrip,
    QC,
    RC5_produktbild,
    redskapsinfastning,
    ripper,
    SOG,
    stengrip,
    R1,
    R2,
    R3,
    R4,
    R5,
    R6,
    R8,
    RC1,
    RC2,
    RC3,
    RC4,
    RC5,
    RC6,
    RC8,
    RC9,
    MG,
    SG,
    GradingBucket,
    TrenchingBucket,
    SortingBucket,
    ExcavationBucketTeeth,
    ExcavationBucket
};
